

import React from 'react';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';

let positionFilter = []
class BubbleSample extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            title: true,
            legends: true,
            exprt: false,
            min: null,
            max: null,
            range: null,
            mean: null,
            variance: null,
            time: null,
            showcomponent: false,
            finalResult: null,
            currentValue: []
        }
    }
    componentDidMount() {
        const {positionFilter, dataNames, length} = this.props;
        console.log(positionFilter, dataNames)

        let optionsArray = [];
        for (let i = 0; i < length; i++) {  
            if(positionFilter.indexOf(i) > -1) {
                const element = dataNames[`positionname${i+1}`]
                const type = dataNames[`positiontype${i+1}`];
                optionsArray.push(`${element} (${type})`)
            }      
        }
        this.setState({currentValue: optionsArray})
        console.log(optionsArray)
    }
    _onClick(currentValue) {
        console.log(currentValue)
        const {length} = this.props;
        let newCurrentValueAll = []
        for (let i = 0; i < length; i++) {  
            newCurrentValueAll.push(i)
        }
        /* const set1 = ["Linear Gradient Descent", "Logistic Gradient Descent", "Anomaly Analysis"]
        const set2 = ["Multiple Scatter", "Multi Linear Regression", "Multi Logistic Regression"]
        const set3 = ["Boxplots", "Descriptive Metrics", "Histograms"]
        set1.indexOf(this.props.currentElement) > 1 && currentValue.length === 2)
        set2.indexOf(this.props.currentElement) > 1 && currentValue.length >= 2)
        set3.indexOf(this.props.currentElement) > 1 && currentValue.length >= 2) */
        if (this.props.currentElement === "Data Preparation") {
            this.props.onSubmit(newCurrentValueAll)
        }
        /* if (this.props.currentElement === "Linear Gradient Descent" && currentValue.length === 2) {
            this.checkForNumber(currentValue)
        } else if (this.props.currentElement === "Logistic Gradient Descent" && currentValue.length === 2) {
            this.checkForNumber(currentValue)
        } else if (this.props.currentElement === "Multiple Scatter" && currentValue.length >= 2) {
            this.checkForNumber(currentValue)
        } else if (this.props.currentElement === "Anomaly Analysis" && currentValue.length === 2) {
            if (this.props.dataNames.positiontype1 === "String" && this.props.dataNames.positiontype2 === "Number") {
                this.props.onSubmit(currentValue)
            } else {
                alert("Anomaly Analysis only accepts string values type 'MM/DD/YYYY JJ:MM' for dependent variable and values type Number for independent variable")
            }
        } else if (this.props.currentElement === "Boxplots" && currentValue.length >= 1) {
            this.checkForNumber(currentValue)
        } else if (this.props.currentElement === "Descriptive Metrics" && currentValue.length >= 1) {
            this.checkForNumber(currentValue)
            //console.log(this.props.dataNames)
            //console.log(positionFilter)
            
        } else if (this.props.currentElement === "Descriptive Metrics CPU" && currentValue.length >= 1) {
            this.props.onSubmit(currentValue)
        } else if (this.props.currentElement === "Histograms" && currentValue.length >= 1) {
            this.checkForNumber(currentValue)
        } else if (this.props.currentElement === "Multi Linear Regression" && currentValue.length >= 2) {
            this.checkForNumber(currentValue)
        } else if (this.props.currentElement === "Multi Logistic Regression" && currentValue.length >= 2) {
            this.checkForNumber(currentValue)
        } else {
            alert("Make sure you have at least 2 numeric variables for Regression or 2 variables for  anomaly analysis")
        } */
    }
    checkForNumber(currentValue) {
        let allNumber = true;
        positionFilter.forEach((ele, index)=>{
            if (this.props.dataNames[`positiontype${ele + 1}`] !== "Number") {
                alert("One of the variables is a string. Make sure to remove this or change the data source to be a number type")
                allNumber = false;
            }
        })
        if (allNumber) this.props.onSubmit(currentValue)
    }
    _onChange(optionsArray, event) {
        positionFilter = []
        event.value.forEach((element, indes) => {
            const position = optionsArray.indexOf(element)
            positionFilter.push(position)
        })
        this.setState({currentValue: event.value})
    }
    _onSelect() {

    }
    _onSort() {

    }
    getOptionsArray(length, dataNames) {
        let optionsArray = [];
        for (let i = 0; i < length; i++) {            
            const element = dataNames[`positionname${i+1}`]
            const type = dataNames[`positiontype${i+1}`];
            optionsArray.push(`${element} (${type})`)
        }
        return optionsArray
    }
    render() {
        const {dataNames, length} = this.props;
        const {currentValue} = this.state;
        const optionsArray = this.getOptionsArray(length, dataNames)
        console.log(this.props.dataObject)
        return (
            <div>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h2><strong>Qualitative Analysis</strong></h2>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Button label='Descriptive Statistics'
                            type='submit'
                            primary={true}
                            onClick={this._onClick.bind(this, positionFilter)} 
                        />
                    </Box>
                </div>
                <hr style={{width: "100%"}} />
                <div>Work On Progress. This section will present qualitative analysis like duplicate values, typos, etc.</div>
                {/* {(this.props.currentElement === "Linear Gradient Descent" ||
                this.props.currentElement === "Logistic Gradient Descent" ||
                this.props.currentElement === "Anomaly Analysis" ||
                this.props.currentElement === "Multi Linear Regression" ||
                this.props.currentElement === "Multi Logistic Regression") ? <div>Note: Last variable in the list should be the independent variable or result (y)</div> : <div></div>}
                <div style={{padding: "30px"}}>
                    <Select 
                        inline={true}
                        multiple={true}
                        options={optionsArray}
                        value={currentValue}
                        onChange={this._onChange.bind(this, optionsArray)} />
                    
        </div> */}
                
            </div>
        );
    }
}


export default BubbleSample;


/* dataready: false,
validateready: false,
selectready: false,
runsready: false, */



// WEBPACK FOOTER //
// ./src/samples/data/dataselect.js